import http from "../http"
import { CreateTeamDTO, Team, UpdateTeamDTO, AdminAddPlayerDTO } from "../../models/team"

class AdminTeamService {
  private readonly baseUrl = "/admin"

  async createTeam(dto: CreateTeamDTO) {
    const { data } = await http.post<Team>(`${this.baseUrl}/team`, dto)
    return data
  }

  async updateTeam(id: string, dto: UpdateTeamDTO) {
    await http.put<Team>(`${this.baseUrl}/team/${id}`, dto)
  }

  async deleteTeam(id: string) {
    const { data } = await http.delete(`${this.baseUrl}/team/${id}`)
    return data
  }

  // Team Players
  async releasePlayer(teamId: string, userId: string) {
    await http.delete(`${this.baseUrl}/team/${teamId}/user/${userId}`)
  }

  async addPlayer(teamId: string, AdminAddPlayerDTO: AdminAddPlayerDTO) {
    await http.post(`${this.baseUrl}/team/${teamId}/user`, AdminAddPlayerDTO)
  }

  async switchManager(teamId: string, userId: string) {
    await http.put(`${this.baseUrl}/team/${teamId}/manager/${userId}`)
  }
}

export default new AdminTeamService()
